import React from "react";
import LegalLayout, { Section } from "./LegalLayout";
import { useConsent } from "../context/ConsentContext";
import { Button } from "../components/ui/button";

export default function CookiePolicy() {
  const { openManage } = useConsent();
  return (
    <LegalLayout title="Política de Cookies" subtitle="Cookies">
      <p className="text-sm text-muted-foreground/80">Última atualização: {new Date().toLocaleDateString("pt-PT")}</p>

      <Section n="1" title="O que são cookies">
        <p>Cookies são pequenos ficheiros guardados no seu dispositivo quando visita um site. Servem para o site funcionar, recordar preferências e, quando autorizado, recolher estatísticas de utilização.</p>
      </Section>

      <Section n="2" title="Cookies e tecnologias que utilizamos">
        <div className="space-y-4">
          <div className="rounded-2xl border border-black/5 bg-secondary/40 p-4">
            <p className="font-semibold text-foreground text-sm">Estritamente necessários (sempre ativos)</p>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1">
              <li><strong>access_token</strong> — mantém a sessão da área de administração.</li>
              <li><strong>cookie-consent-v2</strong> — guarda as suas preferências de cookies.</li>
            </ul>
          </div>
          <div className="rounded-2xl border border-black/5 bg-secondary/40 p-4">
            <p className="font-semibold text-foreground text-sm">Análise / Estatística (só com consentimento)</p>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1">
              <li><strong>PostHog</strong> — ajuda-nos a perceber como o site é utilizado. Fica bloqueado até autorizar.</li>
            </ul>
          </div>
          <div className="rounded-2xl border border-black/5 bg-secondary/40 p-4">
            <p className="font-semibold text-foreground text-sm">Funcionais (só com consentimento)</p>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1">
              <li><strong>Google Maps</strong> — mapa incorporado com a nossa localização. Só carrega depois de autorizar.</li>
            </ul>
          </div>
        </div>
      </Section>

      <Section n="3" title="Gerir ou retirar o consentimento">
        <p>Pode alterar ou retirar o seu consentimento a qualquer momento. As suas escolhas ficam guardadas e podem ser revistas quando quiser.</p>
        <Button data-testid="cookie-policy-manage" onClick={openManage} className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold mt-2">Definições de cookies</Button>
      </Section>
    </LegalLayout>
  );
}
